var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-1", attrs: { fluid: "" } },
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: {
            app: "",
            clipped: "",
            permanent: "",
            floating: "",
            width: "250",
          },
          scopedSlots: _vm._u([
            {
              key: "prepend",
              fn: function () {
                return [
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "", "close-on-content-click": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-6",
                                      attrs: { color: "primary" },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v("+ Add new")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "mx-auto",
                          attrs: { "max-width": "300" },
                        },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c("DialogForm", {
                                attrs: {
                                  title: "Create new case",
                                  "max-width": "600px",
                                  submit: _vm.addCase(_vm.newCaseName),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var onDialog = ref.on
                                      return [
                                        _c(
                                          "v-list-item",
                                          _vm._g({}, onDialog),
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              [
                                                _c("v-icon", [
                                                  _vm._v(
                                                    "mdi-file-plus-outline"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-content", [
                                              _vm._v(" Case "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Name",
                                            placeholder: "New Case",
                                            counter: "64",
                                            rules: [
                                              _vm.$utils.validation.required,
                                              _vm.$utils.validation.counter(64),
                                              _vm.$utils.validation
                                                .specialCharacters,
                                            ],
                                            maxlength: "64",
                                          },
                                          model: {
                                            value: _vm.newCaseName,
                                            callback: function ($$v) {
                                              _vm.newCaseName = $$v
                                            },
                                            expression: "newCaseName",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _c("v-divider"),
                              _c("DialogForm", {
                                attrs: {
                                  title: "Create new folder",
                                  "max-width": "600px",
                                  submit: _vm.createFolder(_vm.newFolderName),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var onDialog = ref.on
                                      return [
                                        _c(
                                          "v-list-item",
                                          _vm._g({}, onDialog),
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              [
                                                _c(
                                                  "v-icon",
                                                  _vm._g({}, _vm.onTooltip),
                                                  [
                                                    _vm._v(
                                                      "mdi-folder-plus-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-content", [
                                              _vm._v(" Folder "),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "default",
                                    fn: function () {
                                      return [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Name",
                                            placeholder: "New Folder",
                                            counter: "64",
                                            rules: [
                                              _vm.$utils.validation.required,
                                              _vm.$utils.validation.counter(64),
                                              _vm.$utils.validation
                                                .specialCharacters,
                                            ],
                                            maxlength: "64",
                                          },
                                          model: {
                                            value: _vm.newFolderName,
                                            callback: function ($$v) {
                                              _vm.newFolderName = $$v
                                            },
                                            expression: "newFolderName",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "v-list",
            { attrs: { dense: "", nav: "" } },
            [
              _c(
                "v-list-item",
                {
                  attrs: {
                    link: "",
                    to: {
                      name: "Home",
                    },
                  },
                },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-home")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Home")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "Folders" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-folder")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Folders")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-list-item",
                [
                  _c("FolderTreeSelect", {
                    attrs: { "opened-root": false },
                    on: { input: _vm.toFolder },
                  }),
                ],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "RecycleBin" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-delete")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Recycle Bin")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "Jobs" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-run")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Jobs")])],
                    1
                  ),
                  _c(
                    "v-list-item-action",
                    [
                      _vm.countRunningJobs
                        ? _c("v-badge", {
                            attrs: {
                              color: "primary",
                              content: _vm.countRunningJobs,
                              inline: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "Deltas" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-triangle")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Deltas")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-list-item",
                { attrs: { link: "", to: { name: "Forecasts" } } },
                [
                  _c(
                    "v-list-item-icon",
                    [_c("v-icon", [_vm._v("mdi-chart-box")])],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Forecasts")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("transition", [_c("keep-alive", [_c("router-view")], 1)], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }